import React from "react";
import classNames from "classnames";

export default function CartItemFeatured(props) {
  return (
    <div>

    <div className="row m-5">
      <div className="col-12 col-lg-5">
        <h4 className="card-title text-center">{props.item.title}</h4>
        <div className="">
          <img src={props.item.img} alt="item" className="img-fluid card-img title-img" />
        </div>
      </div>
      <div className="col-12 col-lg-7">
        <h4 className="card-title text-center">Avaiable options</h4>
        {props.standardOptionValue === "Unavaiable" ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <h2 className=''>Service is unavaiable for this trip</h2>

            </div>
        ) : (
          <div className="d-flex row">
            <div className="col-12 col-md-8">
              <div className="row">
                <label className="d-flex flex-column align-items-center col-12 col-md-6  additional-item-label">
                  <img
                    src={props.standardImg}
                    alt="standard"
                    className="card-img img-fluid add-service-photo"
                  />
                  <div className="d-flex">
                    <input
                      type="radio"
                      name={props.item.title}
                      className="mt-2"
                      value={props.standardOptionValue}
                      checked={
                        props.choosenValue === 0 ||
                        props.choosenValue === "" ||
                        props.choosenValue == props.standardOptionValue
                      }
                      onChange={e => props.handleChange(props.item.id, e)}
                    />
                    <p className="ml-2">Standard</p>
                  </div>
                </label>
                <label className="d-flex flex-column align-items-center col-12 col-md-6 additional-item-label">
                  <img
                    src={props.option1}
                    alt="standard"
                    className="card-img img-fluid add-service-photo"
                  />
                  <div className="d-flex">
                    <input
                      type="radio"
                      name={props.item.title}
                      className="mt-2"
                      value={props.Option1Value}
                      checked={props.Option1Value == props.choosenValue}
                      onChange={e => props.handleChange(props.item.id, e)}
                    
                    />
                    <p className="ml-2">{props.Option1Description}</p>
                  </div>
                </label>
                <label
                  className={classNames(
                    "col-12 col-md-6 additional-item-label",
                    props.Option2Value === undefined ? "hidden" : ""
                  )}
                >
                  <div
                    className={classNames(
                      "d-flex flex-column align-items-center "
                    )}
                  >
                    <img
                      src={props.option2}
                      alt="standard"
                      className="card-img img-fluid add-service-photo"
                    />
                    <div className="d-flex">
                      <input
                        type="radio"
                        name={props.item.title}
                        className="mt-2"
                        value={props.Option2Value}
                        checked={props.Option2Value == props.choosenValue}
                        onChange={e => props.handleChange(props.item.id, e)}
                      />
                      <p className="ml-2">{props.Option2Description}</p>
                    </div>
                  </div>
                </label>
                <label
                  className={classNames(
                    "col-12 col-md-6 additional-item-label",
                    props.Option3Value === undefined ? "hidden" : ""
                  )}
                >
                  <div
                    className={classNames(
                      "d-flex flex-column align-items-center"
                    )}
                  >
                    <img
                      src={props.option3}
                      alt="standard"
                      className="card-img img-fluid add-service-photo"
                    />
                    <div className="d-flex">
                      <input
                        type="radio"
                        name={props.item.title}
                        className="mt-2"
                        value={props.Option3Value}
                        checked={props.Option3Value == props.choosenValue}
                        onChange={e => props.handleChange(props.item.id, e)}
                      />
                      <p className="ml-2">{props.Option3Description}</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div className="col-12 col-md-4 align-self-center">
              <div className="mb-3">
                <h5 className="card-subtitle text-center text-bold mb-3">
                  Price
                </h5>
                <div>
                  <ul className="">
                    <li>
                      Standard: <p>no additional fee</p>
                    </li>
                    <li>
                      {props.Option1Description}: <p>${props.Option1Value} </p>
                    </li>
                    <li
                      className={classNames(
                        props.Option2Value === undefined ? "hidden" : ""
                      )}
                    >
                      {props.Option2Description}: <p>${props.Option2Value} </p>
                    </li>
                    <li
                      className={classNames(
                        props.Option3Value === undefined ? "hidden" : ""
                      )}
                    >
                      {props.Option3Description}: <p>${props.Option3Value} </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <h5 className="card-subtitle text-center text-bold">
                  Picked option
                </h5>
                <p className="text-center">
                  {props.choosenValue == props.standardOptionValue || props.choosenValue == ''
                    ? "Standard"
                    : props.choosenValue == props.Option1Value
                    ? props.Option1Description
                    : props.choosenValue == props.Option2Value
                    ? props.Option2Description
                    : props.Option3Description}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    {props.line ? <hr /> : null}
    </div>
  );
}
